/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddProfileIntegrationRequest } from '../models/AddProfileIntegrationRequest';
import type { AddProfileIntegrationResponse } from '../models/AddProfileIntegrationResponse';
import type { CreateGmailInboxListenerRequest } from '../models/CreateGmailInboxListenerRequest';
import type { CreateGmailInboxListenerResponse } from '../models/CreateGmailInboxListenerResponse';
import type { CreateOutlookInboxListenerRequest } from '../models/CreateOutlookInboxListenerRequest';
import type { CreateOutlookInboxListenerResponse } from '../models/CreateOutlookInboxListenerResponse';
import type { GetGmailOAuthTokensRequest } from '../models/GetGmailOAuthTokensRequest';
import type { GetGmailOAuthTokensResult } from '../models/GetGmailOAuthTokensResult';
import type { GetMicrosoftOutlookOAuthTokenRequest } from '../models/GetMicrosoftOutlookOAuthTokenRequest';
import type { GetMicrosoftOutlookOAuthTokensResponse } from '../models/GetMicrosoftOutlookOAuthTokensResponse';
import type { Integration } from '../models/Integration';
import type { IntegrationType } from '../models/IntegrationType';
import type { OrgProfileIntegration } from '../models/OrgProfileIntegration';
import type { UpdateGmailOrgIntegrationProfileRequest } from '../models/UpdateGmailOrgIntegrationProfileRequest';
import type { UpdateGmailOrgIntegrationProfileResponse } from '../models/UpdateGmailOrgIntegrationProfileResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IntegrationsService {

    /**
     * Adds or updates an org profile integration record to the database.
     * @param organizationId The organization id
     * @param requestBody The request body
     * @returns AddProfileIntegrationResponse OK
     * @throws ApiError
     */
    public static addProfileIntegration(
        organizationId: string,
        requestBody?: AddProfileIntegrationRequest,
    ): CancelablePromise<AddProfileIntegrationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/organization/{organizationId}/addProfileIntegration',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static arTaskGmailListener(
        requestBody?: any,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/gmail/listen/ar-task',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Sends a watch request to the Gmail API to watch the inbox of the user.
     * @NOTE: This api should be immediately invoked after a fresh Integration is done within rally.
     * @param requestBody The request body
     * @returns CreateGmailInboxListenerResponse OK
     * @throws ApiError
     */
    public static createGmailInboxListener(
        requestBody?: CreateGmailInboxListenerRequest,
    ): CancelablePromise<CreateGmailInboxListenerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/createGmailInboxListener',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Sends a watch request to the Microsoft Outlook API to watch the inbox of the user.
     * @NOTE: This api should be immediately invoked after a fresh Integration is done within rally.
     * @param requestBody The request body
     * @returns CreateOutlookInboxListenerResponse OK
     * @throws ApiError
     */
    public static createOutlookInboxListener(
        requestBody?: CreateOutlookInboxListenerRequest,
    ): CancelablePromise<CreateOutlookInboxListenerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/createOutlookInboxListener',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets integrations for the dropdown in the new integration drawer
     * @returns Integration OK
     * @throws ApiError
     */
    public static getIntegrations(): CancelablePromise<Array<Integration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/getIntegrations',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration of an organization.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @param integrationType type of integration as an optional filter
     * @returns OrgProfileIntegration OK
     * @throws ApiError
     */
    public static getOrgIntegrations(
        organizationId: string,
        integrationType?: IntegrationType,
    ): CancelablePromise<Array<OrgProfileIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/organizations/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'integrationType': integrationType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration of an organization.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns OrgProfileIntegration OK
     * @throws ApiError
     */
    public static getOrgProfileOAuthConfig(
        organizationId: string,
    ): CancelablePromise<Array<OrgProfileIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/organizations/{organizationId}/oAuthConfig',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieves the Google OAuth tokens based on the authorization code using OAuth 2.0. flow
     * @param requestBody The request body
     * @returns GetGmailOAuthTokensResult OK
     * @throws ApiError
     */
    public static getGmailOAuthTokens(
        requestBody?: GetGmailOAuthTokensRequest,
    ): CancelablePromise<GetGmailOAuthTokensResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/gmail/getGmailOAuthTokens',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Listens for any email replies on behalf of a user
     * and stores the message as a notification in the database. This Endpoint is used with GCP Pub/Sub
     * @TODO: We need to revisit this to authenticate the request.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static gmailListener(
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/gmail/listen',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Listens for any email replies on behalf of a user within a workflow if email node is present.
     * and stores the message as a notification in the database. This Endpoint is used with GCP Pub/Sub
     * @TODO: We need to revisit this to authenticate the request.
     * @param organizationId The organization id
     * @param userId The user id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static orgIntegrationEmailListener(
        organizationId: string,
        userId: string,
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizations/{organizationId}/user/{userId}/email/listen',
            path: {
                'organizationId': organizationId,
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Retrieves the Microsoft Outlook OAuth tokens based on the authorization code using OAuth 2.0. flow
     * @param requestBody The request body
     * @returns GetMicrosoftOutlookOAuthTokensResponse OK
     * @throws ApiError
     */
    public static getMicrosoftOutlookOAuthTokenss(
        requestBody?: GetMicrosoftOutlookOAuthTokenRequest,
    ): CancelablePromise<GetMicrosoftOutlookOAuthTokensResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/gmail/getMicrosoftOutlookOAuthTokens',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Listens for any outlook email replies on behalf of a user
     * and stores the message as a notification in the database. This Endpoint is used with Microsoft outlook subscriptions
     * Source: https://learn.microsoft.com/en-us/graph/outlook-change-notifications-overview
     * @TODO: We need to revisit this to authenticate the request.
     * @param validationToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static outlookListener(
        validationToken?: string,
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/outlook/listen',
            query: {
                'validationToken': validationToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Listens for any email replies on behalf of a user
     * and stores the message as a notification in the database. This Endpoint is used with GCP Pub/Sub
     * @TODO: We need to revisit this to authenticate the request.
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static outlookSubscriptionRenewalJobHandler(
        requestBody?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/outlook/subscriptions/renew',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration of an organization.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @param requestBody
     * @returns UpdateGmailOrgIntegrationProfileResponse OK
     * @throws ApiError
     */
    public static updateGmailOrgIntegrationProfile(
        organizationId: string,
        requestBody?: UpdateGmailOrgIntegrationProfileRequest,
    ): CancelablePromise<UpdateGmailOrgIntegrationProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/organizations/{organizationId}/updateGmailOrgIntegrationProfile',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Gets the access token for the Zendesk integration of a user.
     * @param organizationId
     * @returns OrgProfileIntegration OK
     * @throws ApiError
     */
    public static getProfileIntegrations(
        organizationId: string,
    ): CancelablePromise<Array<OrgProfileIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizations/{organizationId}/integrations/getProfileIntegrations',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
